<template>
  <section class="flex-col">
    <h2 id="sdg-heading">Explore SDG Filters</h2>
    <p class="subHeading">
      Find opportunities that support the change you want to see.
    </p>

    <div class="content">
      <p>
        At EquiRize, you can easily filter opportunities aligned with the UN
        Sustainable Development Goals (SDGs), a global framework for addressing
        issues like gender inequality, climate change, and economic inclusion.
        Choosing SDG-aligned opportunities can help counter long-term risks
        while ensuring your investments reflect your values. While not all
        offerings are SDG-aligned, we clearly label those that are and are
        committed to growing their share on our platform.
      </p>
      <img
        src="/assets/images/home/globe.svg"
        class="img-fluid"
        alt="Sustainable development goals globe illustration"
      />
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.content {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.img-fluid {
  width: 80%;
}

@media (min-width: 1024px) {
  .content {
    width: 70%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 100px;
  }

  .img-fluid {
    width: 400px;
  }
}
</style>
